import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

export function ProductCard({ product, onAddToCart }) {
  return (
    <div 
      className="product-card bg-white rounded-[1.5rem] overflow-hidden border border-forest/10 shadow-card flex flex-col"
      data-testid={`product-card-${product.product_id}`}
    >
      {/* Image */}
      <Link to={`/product/${product.product_id}`} className="block relative overflow-hidden aspect-[4/3]">
        <img
          src={product.image_url}
          alt={product.name}
          className="product-image w-full h-full object-cover"
          loading="lazy"
        />
        {product.is_organic && (
          <span className="absolute top-4 left-4 badge-organic">
            Organic
          </span>
        )}
      </Link>

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow">
        <div className="mb-2">
          <span className="text-xs font-manrope font-medium text-forest/70 uppercase tracking-wider">
            {product.category}
          </span>
        </div>
        
        <Link to={`/product/${product.product_id}`}>
          <h3 className="font-playfair text-xl font-semibold text-dark mb-2 hover:text-forest transition-colors">
            {product.name}
          </h3>
        </Link>
        
        <p className="text-dark/60 font-manrope text-sm mb-4 line-clamp-2 flex-grow">
          {product.description}
        </p>

        <div className="flex items-center justify-between gap-4 pt-4 border-t border-forest/10">
          <div>
            <p className="font-playfair text-2xl font-bold text-dark">
              ${product.price.toFixed(2)}
            </p>
            <p className="text-xs text-dark/50 font-manrope">{product.serving_size}</p>
          </div>
          
          <button
            onClick={(e) => {
              e.preventDefault();
              onAddToCart?.(product);
            }}
            className="flex items-center gap-2 bg-forest hover:bg-forest-dark text-white px-4 py-2.5 rounded-full font-manrope font-medium text-sm transition-all hover:-translate-y-0.5"
            data-testid={`add-to-cart-${product.product_id}`}
          >
            <ShoppingCart className="w-4 h-4" />
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
